import { Injectable } from '@angular/core';
import { Http, Headers, URLSearchParams, RequestOptions } from '@angular/http';

@Injectable()
export class SalesTeamReportService {
    private headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' });
    private apiUrl = 'api/salesTeamReport';

    constructor(private http: Http) { }

    private extractData(res: any) {
        return res.json() || {};
    }

    getSalesTeamIndividualReport(query: any): Promise<any> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) { params.set(key.toString(), query[key]); }
        let options = new RequestOptions({ headers: this.headers, search: params });
        return this.http.get(`${this.apiUrl}/getReport`, options)
            .toPromise().then(this.extractData).catch(err => [JSON.parse(err._body)]);
    }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/services/salesTeamReport.service.ts